import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { PERSONAL_DETAILS_PATH } from '../../../tabs/PersonalDetails/routes/routePaths';
import {
  ModalWrapper,
  ModalContent,
  ModalTitle,
  ModalText,
  ButtonWrapper,
  Link
} from './EditOrderModal.styles';
import Caution from '../Icons/Caution';
import '@carvana/showroom-forms/Button/index.css';

const EditOrderModal = () => {
  const history = useHistory();
  const navigate = (value: string) => history.push(value);
  const [openModal, setOpenModal] = useState(true);
  const closeModal = () => {
    navigate(PERSONAL_DETAILS_PATH);
  };

  return (
    <ModalWrapper
      headerText="Edit Address"
      isOpen={openModal}
      closeModal={closeModal}
      disableBackdropClick
    >
      <ModalContent>
        <Caution />
        <ModalTitle>Are you sure you want to edit your address?</ModalTitle>
        <ModalText>
          Editing your address information will not update your current purchase. If you need to
          make changes to your purchase, please <Link href="/purchase/dashboard">click here</Link>{' '}
          for next steps.
        </ModalText>
        <ButtonWrapper>
          <SecondaryButton
            onClick={() => {
              setOpenModal(!openModal);
            }}
          >
            Yes, edit
          </SecondaryButton>
          <PrimaryButton onClick={() => navigate(PERSONAL_DETAILS_PATH)}>No, go back</PrimaryButton>
        </ButtonWrapper>
      </ModalContent>
    </ModalWrapper>
  );
};

export default EditOrderModal;
